import { useEffect, useState } from "react";
import { parseGeoData } from "senf-shared";
import { Map } from "mapbox-gl";
import { setGeoJSONLayer } from "./useGeojson";

export const useGisData = () => {
  const [source, setSource] = useState(null);
  const [points, setPoints] = useState(null);

  useEffect(() => {
    if (source && points) {
      const newData = Array.isArray(points) ? points : [points];

      const mergedData = {
        type: "FeatureCollection",
        features: [],
      };
      newData.forEach((data) => {
        const parsedData = parseGeoData(data);

        const convertedData =
          parsedData?.type === "FeatureCollection" ? parsedData : data?.data;
        if (
          convertedData?.type === "FeatureCollection" &&
          convertedData?.features
        ) {
          mergedData.features = mergedData.features.concat(
            convertedData.features
          );
        } else if (data?.[0] && data?.[0]?.data?.features) {
          mergedData.features = mergedData.features.concat(
            data[0].data.features
          );
        }
      });

      if (mergedData?.features?.length) {
        source.setData(mergedData);
      } else {
        source.setData({
          type: "FeatureCollection",
          features: [],
        });
      }
    } else if (source && !points) {
      source.setData({
        type: "FeatureCollection",
        features: [],
      });
    }
  }, [source, points]);

  const setLayer = (map: Map) => {
    const sourceId = "gisData";
    // After the map style has loaded on the page,
    // add a source layer and default styling for a single point
    map.on("load", () => {
      let s = map.getSource(sourceId);
      if (!s) {
        setGeoJSONLayer(map);

        s = map.getSource(sourceId);
      }

      setSource(s);
    });
  };

  return [setLayer, setPoints] as const;
};
